import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=088aa101&scoped=true"
import script from "./Translations.vue?vue&type=script&lang=js"
export * from "./Translations.vue?vue&type=script&lang=js"
import style0 from "./Translations.vue?vue&type=style&index=0&id=088aa101&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088aa101",
  null
  
)

export default component.exports